import { Pipe, PipeTransform } from '@angular/core';
import { IBookingCarbonFootprint } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { ICarbonFootPrint } from "libraries/component/carbon-footprint/carbon-footprint.interface";

@Pipe({
    name: 'getDataForSelection'
})
export class GetDataForSelectionPipe implements PipeTransform {
    public transform(value: IBookingCarbonFootprint[], selection: string[]): ICarbonFootPrint {
        if (!value) {
            return null;
        }

        if (!value.length) {
            return null;
        }

        if (value.length === 1) {
            return value[0].carbonFootprint || value[0].carbonFootPrint;
        }
        const keyCompare: string = selection.join('-');

        const relatedCarbonFootprint: IBookingCarbonFootprint = value
            .find((bookingCarbonFootprint: IBookingCarbonFootprint) => {
                return bookingCarbonFootprint.journeyKey === keyCompare;
            });
        return relatedCarbonFootprint ? relatedCarbonFootprint.carbonFootprint : null;
    }
}
